import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  input: {
    '& input': {
      textAlign: 'right',
    },
    '& .MuiInputBase-formControl': {
      borderRadius: 6,
      padding: '10px 4px!important',
    },
    '& #input-error': {
      fontSize: 10,
    },
  },
}));
